import { ViewEntityType } from "./viewEntityType";

type ViewEntityCollisionWeight = {
  [key in ViewEntityType]?: number;
};

// the collision weight of polyline objects (as bounding boxes) in pdf drawings
// higher means more avoidance
export const DefaultViewEntityCollisionWeight: ViewEntityCollisionWeight = {
  [ViewEntityType.NONE]: 0.1,
  [ViewEntityType.GABLE_ROOF_VENT]: 5,
  [ViewEntityType.FASCIA]: 4,
  [ViewEntityType.EAVE_FASCIA]: 2,
  [ViewEntityType.EAVE_SOFFIT]: 2,
  [ViewEntityType.FASCIA_TRIM]: 2,
  [ViewEntityType.RAFTER_EXTENSION]: 2,
  [ViewEntityType.BOX_EAVE]: 2,
  [ViewEntityType.MINI_HIP_EAVE]: 2,
  [ViewEntityType.MINI_HIP_ROOF]: 2,
  [ViewEntityType.MINI_SHED_EAVE]: 2,
  [ViewEntityType.MINI_SHED_ROOF]: 2,
  [ViewEntityType.WINDOW_EXTERIOR_TRIM]: 20,
  [ViewEntityType.DOOR_EXTERIOR]: 20,
  [ViewEntityType.PROFILE_EXTRUSION]: 2,
  [ViewEntityType.COLUMN]: 5,
  [ViewEntityType.RAILING]: 5,
};

export interface EntityAnnotationSetting {
  readonly enabled: boolean;
  readonly text?: string;
  readonly tagOnlyOne?: boolean;
}

export interface EntityAnnotationOptions {
  readonly enabled: boolean;
  readonly delegatedUI?: boolean;
}

// developer control for which categories show up in the settings panel
export const EntityAnnotationEnabledTypes: { [key in ViewEntityType]?: EntityAnnotationOptions } = {
  [ViewEntityType.NONE]: { enabled: false },
  [ViewEntityType.BOX_EAVE]: { enabled: true },
  [ViewEntityType.DOOR_EXTERIOR]: { enabled: false },
  [ViewEntityType.EAVE_FASCIA]: { enabled: true },
  [ViewEntityType.EAVE_SOFFIT]: { enabled: true },
  [ViewEntityType.FASCIA]: { enabled: true },
  [ViewEntityType.FASCIA_TRIM]: { enabled: true },
  [ViewEntityType.GABLE_ROOF_VENT]: { enabled: true },
  [ViewEntityType.MINI_HIP_EAVE]: { enabled: true },
  [ViewEntityType.MINI_HIP_ROOF]: { enabled: true },
  [ViewEntityType.MINI_SHED_EAVE]: { enabled: true },
  [ViewEntityType.MINI_SHED_ROOF]: { enabled: true },
  [ViewEntityType.RAFTER_EXTENSION]: { enabled: true },
  [ViewEntityType.WINDOW_EXTERIOR_TRIM]: { enabled: false },
  [ViewEntityType.PROFILE_EXTRUSION]: { enabled: true, delegatedUI: true }, // uses Profile Settings Menu
  [ViewEntityType.COLUMN]: { enabled: true, delegatedUI: true }, //TODO: create column catalog
};

type EntityAnnotationSettingsTable = { [key in ViewEntityType]?: EntityAnnotationSetting };

//in one flat object for settings override functionality
export type ViewNotesSettingsTable = EntityAnnotationSettingsTable & {
  readonly typicalSuffix: string;
};
